import { INewbuildingOffer } from 'shared/types/newbuildingOffersCarousel';

interface IGetNewbuildingOffersPositionsParams {
  step: number;
  activeSlideIndex: number;
  offers: INewbuildingOffer[];
  isKpn: boolean;
}

interface IOfferPosition {
  id: number | null;
  position: number;
  offerType: 'offer' | 'kpn';
}

export function getNewbuildingOffersPositions({
  step,
  activeSlideIndex,
  offers,
  isKpn,
}: IGetNewbuildingOffersPositionsParams): IOfferPosition[] {
  const ids: (number | null)[] = offers.map(offer => offer.id);

  // Вставляем KPN на вторую позицию перед слайсом, если нужно
  if (isKpn && ids.length > 1) {
    ids.splice(1, 0, null); // вставка на индекс 1
  }

  const slicedIds = ids.slice(activeSlideIndex, activeSlideIndex + step);

  return slicedIds.map((id, index) => ({
    id,
    position: activeSlideIndex + index + 1,
    offerType: id === null ? 'kpn' : 'offer',
  }));
}
